// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-module___tabs___bf7214b5"};